import { ReactComponent as Empty } from "../../../../common/assets/icons/empty.svg";
import { useEffect } from "react";
import { ReactComponent as Dropdown } from "../../../assets/icons/dropdown.svg";

interface MemberTableProps {
    data: {
        member_idx: number;
        m_name: string;
        m_email: string;
        m_mobile: string;
        reg_date: string;
        customer_name: string;
        order_count: number;
        total_sales_amount: number;
    }[];
    onRowClick: (memberIdx: number) => void;
    newMember: boolean;
    selectedMemberIdx?: number;
    onSort: (field: string) => void;
}

const MemberTable = ({ data, onRowClick, newMember, selectedMemberIdx, onSort }: MemberTableProps) => {
    const handleRowClick = (memberIdx: number) => {
        onRowClick(memberIdx);
    };

    useEffect(() => {
        if (data.length > 0 && (selectedMemberIdx === undefined || selectedMemberIdx === null)) {
            const firstMemberIdx = data[0].member_idx;
            onRowClick?.(firstMemberIdx);
        }
    }, [data, selectedMemberIdx]);

    return (
        <div className="h-full">
            <table className="table-fixed w-full text-gray2">
                {/* Header */}
                <thead className=" text-sm border-y border-gray3 h-10">
                    <tr>
                        <th className="px-2">
                            <div className="flex items-center gap-4 justify-between">
                                <p>고객명</p>
                                <Dropdown className="cursor-pointer" onClick={() => onSort("customer_name")} />
                            </div>
                        </th>
                        <th className="px-2 text-start w-[100px] border-r border-gray4">회원명</th>
                        <th className="px-2 text-start w-[120px]">가입일자</th>
                        <th className="px-2 text-start">연락처 / 이메일</th>
                        <th className="px-2 w-[100px]">주문건수</th>
                        <th className="px-2 text-end">누적 판매금액</th>
                    </tr>
                </thead>
                {/* Body */}
                <tbody>
                    {data.length > 0 ? (
                        data.map(member => (
                            <tr
                                key={member.member_idx}
                                className={`border-b border-gray4 text-sm h-[50px] cursor-pointer hover:bg-[#E6EEDD] 
                                    ${selectedMemberIdx === member.member_idx ? (newMember ? "" : "bg-[#F9EBEB]") : ""}`}
                                onClick={() => handleRowClick(member.member_idx)}
                            >
                                <td className="px-2">{member.customer_name}</td>
                                <td className="px-2 border-r border-gray4">{member.m_name}</td>
                                <td className="px-2 text-xs text-gray3">{member.reg_date.slice(0, 16)}</td>
                                <td className="px-2 text-xs">
                                    <div className="flex flex-col">
                                        <p>{member.m_mobile}</p>
                                        <p>{member.m_email}</p>
                                    </div>
                                </td>
                                <td className="px-2 text-center">{member.order_count}건</td>
                                <td className="px-2 text-end">{member.total_sales_amount.toLocaleString()} 원</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={6} className="text-center">
                                <div className="flex flex-col items-center gap-5 py-4 mt-52">
                                    <Empty />
                                    <p className="text-grayicon text-lg">등록된 내역이 없습니다.</p>
                                </div>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default MemberTable;
